import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

import styles from "./invalidPaymentLinkStyles";
import InvalidPaymentLinkView from "./invalidPaymentLinkView";

class InvalidPaymentLinkComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false,
      errorMessage: "",
      showSuccess: false,
      successMessage: "",
    };
  }

  componentDidMount() {
    document.title = "Lien de paiement invalide | Landing Zone";
  }

  render() {
    const { classes } = this.props;

    return (
      <>
        <InvalidPaymentLinkView
          {...this.props}
          state={this.state}
          classes={classes}
        />
      </>
    );
  }
}

export default withTranslation()(
  withStyles(styles, { withTheme: true })(
    withRouter(InvalidPaymentLinkComponent)
  )
);
